import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateTwitchMembershipsDiscountMutation = createMutationHook(
  MembershipsCreatorApiClient.updateTwitchDiscount,
  {
    mutationKey: ['updateTwitchMembershipsDiscount'],
  },
)
